import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Trust() {
  const testimonials = [{
    quote: 'Strata handles all our custom apparel — T-shirts, hoodies, vests, and hats. The quality is bulletproof and the turnaround is always on point.',
    author: 'Rogelio Silva',
    role: 'Owner, 1st Choice Drywall'
  }, {
    quote: 'We needed T-shirts for our entire crew and Strata delivered fast with incredible quality. They made the whole process easy.',
    author: 'Eran Mizan',
    role: 'Founder, EcoTech'
  }];
  return <section className="py-24 bg-black text-white" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-160">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-161">
            Trusted by Businesses That Don't Settle
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto font-medium" data-id="element-162">
            From restaurants and construction crews to landscapers, gyms,
            schools, and small businesses — we've printed millions of pieces
            over 30+ years.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-163">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-neutral-900 border-2 border-neutral-800 p-8" data-id="element-164">
              <div className="flex gap-1 mb-6" data-id="element-165">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-white text-white" data-id="element-166" />)}
              </div>
              <p className="text-xl font-medium mb-6 leading-relaxed" data-id="element-167">
                "{t.quote}"
              </p>
              <div data-id="element-168">
                <p className="font-display font-bold uppercase tracking-wider text-lg" data-id="element-169">
                  {t.author}
                </p>
                <p className="text-gray-400" data-id="element-170">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}